import GalleryCustomViewOptionsStore from "csi/middleware/customView/options/GalleryCustomViewOptionsStore";
import { isDefined } from "csi/utility/coreUtility";
import { Box, FlexColumn, TextField } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import css from "./CustomViewOptions.module.css";

// TODO - displaying of "Rows per page" option is conditional, see csi/gallery/PrefsOptions.js for details 
const PrintOptionRowsPerPage: FunctionComponent = observer(function PrintOptionRowsPerPage(props) {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		displayGalleryRowsPerPage,
		galleryRowsPerPage,
		hasGalleryRowsPerPageValidationError,
		galleryRowsPerPageValidationMsg,
		setPrintOptionRowsPerPage,
		showGalleryRowsPerPage,
	} = optionsStore as GalleryCustomViewOptionsStore;

	return (
		<>
			{isDefined(galleryRowsPerPage) && showGalleryRowsPerPage && (
				<Box className={css.container}>
					<FlexColumn className={css.optionLeft}>
						<TextField
							error={!!hasGalleryRowsPerPageValidationError}
							helperText={galleryRowsPerPageValidationMsg}
							onChange={setPrintOptionRowsPerPage}
							placeholderRes="ViewPreferences_DefaultValue"
							res="CustomViewRowsPerPage"
							value={displayGalleryRowsPerPage}
						/>
					</FlexColumn>
				</Box>
			)}
		</>
	);
});

export default PrintOptionRowsPerPage;